// extracted by mini-css-extract-plugin
module.exports = {"comparelist":"CompareList_comparelist__EDJn_","compareDropdown":"CompareList_compareDropdown__NVrE4"};